import AccessRightsUserSupportPage from "../../../component/users/support/AccessRightsUserSupport"

 
 
function AccessRightsUserSupport() {
  return (
    <div className="page-body"><AccessRightsUserSupportPage/></div>
  )
}

export default AccessRightsUserSupport